// This is for the select in QuoteReader
export const quoteApprovalOptions = [
  { value: true, label: 'Customer Approved' },
  { value: false, label: 'Customer Declined' },
  { value: null, label: 'No Customer Response' },
];

export const PageLimits = {
  messages: 50,
  threads: 50,
  autoCrud: 50,
};
Object.freeze(PageLimits);

export const colors = {
  darkBlue: '#0D47A1',
  lightGreen: '#CAEEC2',
  lightGrey: '#DCD2D3',
  lightRed: '#F7A8B2',
};
Object.freeze(colors);

export const partConditions = [
  { text: 'Select...', value: '' },
  { text: 'New OEM', value: 'New OEM' },
  { text: 'New', value: 'New' },
  { text: 'OEM Surplus', value: 'OEM Surplus' },
  { text: 'Used', value: 'Used' },
  { text: 'Rebuilt', value: 'Rebuilt' },
  { text: 'Reconditioned', value: 'Reconditioned' },
] as const;

export const states = [
  'AL',
  'AK',
  'AS',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'VI',
  'WA',
  'WV',
  'WI',
  'WY',
];

Object.freeze(states);
